export default __webpack_public_path__ + "static/media/history.8f614f79.svg";